import { api, obtenerValoresFiltros } from '../../global/js/funciones';

export const GENERICA_SIDEBAR_APPS = 49;

export const INICIO_APPS_DESKTOP_MIN_PX = 768;


function normalizarTexto(v) {
  return String(v ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** AGIL, CUC, SICUC, CUCO, etc.: logos muy anchos — UI más compacta */
export function itemEsAccesoLogoAncho(item) {
  const n = String(item?.nombre || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (!n) return false;
  if (n.includes('agil')) return true;
  if (n.includes('sicuc') || n.includes('sicu')) return true;
  if (n.includes('cuco')) return true;
  if (n.includes('cuc')) return true;
  return false;
}

export function imagenDesdeItem(item) {
  const a = item?.archivo;
  if (!a) return null;
  const s = String(a).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.startsWith('/') ? s : `/${s}`;
  return `${api}${path}`;
}

/**
 * URL en valorb para accesos rápidos (genérica 49).
 * valora === 'link' indica enlace explícito; también se aceptan http(s), /, mailto, tel, www.
 */
export function obtenerUrlAccesoRapido(item) {
  const raw = String(item?.valorb ?? '').trim();
  if (!raw) return null;
  if (/^javascript:/i.test(raw) || /^data:/i.test(raw)) return null;
  const tipo = String(item?.valora ?? '').toLowerCase().trim();
  const esTipoLink = tipo === 'link';

  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('//')) return `https:${raw}`;
  if (raw.startsWith('/')) return raw;
  if (/^mailto:/i.test(raw) || /^tel:/i.test(raw)) return raw;
  if (/^www\./i.test(raw)) return `https://${raw}`;
  if (esTipoLink && /^[a-z0-9.-]+\.[a-z]{2,}/i.test(raw)) return `https://${raw}`;
  if (esTipoLink) return raw;
  return null;
}

export function itemRequiereJwtEmma(item) {
  if (normalizarTexto(item?.valorc) === 'ecotic') return true;
  const url = String(item?.valorb ?? '').trim();
  return /\/auth\/emma(\?|$)/i.test(url);
}


export function itemSoloEstudiante(item) {
  return normalizarTexto(item?.valorc) === 'ecotic';
}


function construirUrlConJwtEmma(baseUrl) {
  const token = localStorage.getItem('token');
  if (!token) return baseUrl;
  try {
    const urlObj = new URL(baseUrl, window.location.href);
    // Si el path no termina en /auth/emma, lo agregamos
    if (!/\/auth\/emma$/i.test(urlObj.pathname.replace(/\/$/, ''))) {
      urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/auth/emma';
    }
    urlObj.searchParams.set('emma_jwt', token);
    return urlObj.toString();
  } catch {
    // Si URL no es parseable, construir manualmente
    const base = baseUrl.replace(/\/$/, '');
    return `${base}/auth/emma?emma_jwt=${encodeURIComponent(token)}`;
  }
}

/** Redirección en pestaña nueva; true si hubo navegación. */
export function redireccionarAccesoRapido(item) {
  let url = obtenerUrlAccesoRapido(item);
  if (!url) return false;
  if (itemRequiereJwtEmma(item)) {
    url = construirUrlConJwtEmma(url);
  }
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) return false;
  return true;
}

export function puedeVerItem(item) {
  const vf = String(item?.valorf ?? '')
    .trim()
    .toLowerCase();
  if (
    vf === 'no' ||
    vf === 'false' ||
    vf === 'inactivo' ||
    vf === 'off' ||
    vf === 'inactiva'
  ) {
    return false;
  }
  const va = String(item?.valora ?? '')
    .trim()
    .toLowerCase();
  if (va === 'inactivo' || va === 'inactiva') {
    return false;
  }
  return true;
}

export function itemActivoEnInicio(item) {
  return normalizarTexto(item?.valorg) === 'si';
}

export function normalizarListaRespuesta(raw) {
  if (Array.isArray(raw)) return raw;
  if (raw == null) return [];
  if (Array.isArray(raw.results)) return raw.results;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.valores)) return raw.valores;
  if (Array.isArray(raw.result)) return raw.result;
  if (typeof raw === 'object') {
    const values = Object.values(raw);
    const found = values.find(
      (v) =>
        Array.isArray(v) &&
        (v.length === 0 ||
          (v[0] != null && typeof v[0] === 'object' && !Array.isArray(v[0])))
    );
    if (found) return found;
  }
  return [];
}

export function ordenarItems(lista) {
  return [...(lista || [])].sort((a, b) => {
    const oa = Number(a.valorf);
    const ob = Number(b.valorf);
    if (!Number.isNaN(oa) && !Number.isNaN(ob) && oa !== ob) return oa - ob;
    return String(a.nombre || '').localeCompare(String(b.nombre || ''));
  });
}

export async function fetchGenerica49Apps() {
  const raw = await obtenerValoresFiltros([
    { llave: 'generica', valor: GENERICA_SIDEBAR_APPS },
    { llave: 'estado', valor: '1' },
  ]);
  const lista = normalizarListaRespuesta(raw);
  return ordenarItems(lista.filter((it) => itemActivoEnInicio(it)));
}
